export default {
    "success_reservation":{
        "title":"Reserve a seat",
        "content_title":"Congratulations!",
        "content":"You have reserved a seat at a new event. <br> You can cancel your reservation at any time.",
        "btn_wrapper_classes":"buttons_wrapper_between center",
        "btns":[
            {
                "title":"OK",
                "classes":"btn w180",
                "func":"closeReservationModal"
            }
        ]
    },
    "success_reservation_cancel":{
        "title":"Cancel reservation",
        "content_title":null,
        "content":"Your reservation was successfully canceled.",
        "btn_wrapper_classes":"buttons_wrapper_between center",
        "btns":[
            {
                "title":"OK",
                "classes":"btn",
                "func":"closeReservationModal"
            }
        ]
    },
    "confirm_reservation_cancel":{
        "title":"Cancel reservation",
        "content_title":null,
        "content":null,
        "btn_wrapper_classes":"buttons_wrapper_between",
        "btns":[
            {
                "title":"No",
                "classes":"btn white mr30",
                "func":"closeReservationModal"
            },
            {
                "title":"Yes",
                "classes":"btn ",
                "func":"cancelReserveSeatConfirmed"
            }
        ]
    }
}
